import { render, staticRenderFns } from "./damac-riverside.vue?vue&type=template&id=4a06d476&"
import script from "./damac-riverside.vue?vue&type=script&lang=js&"
export * from "./damac-riverside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports